
import React, { useState, useEffect, useRef } from "react";
// import { RiErrorWarningFill } from "react-icons/ri";
import { PiWarningCircleBold } from "react-icons/pi";
import { Check, CheckCheck, RefreshCw, Download, Play, Pause, Mic, FileText, X, Smile, ChevronLeft, ChevronRight, PhoneIncoming, PhoneOutgoing, ShieldAlert, ShieldCheck, PhoneCall, Info, Bell } from "lucide-react";
import { useAPI } from "../Context/MyContext";
import TemplateMessage from "../Component/braodcasting/TemplateMessage";
import { useStateContex } from "../Context/UseStateContet";
import parse from "whatsapp-markdown";
const REACTIONS = ["👍", "❤️", "😂", "😮", "😢", "🙏"];

const Message = ({ message: initialMessage, setMessages, phoneId, setReplyMessage }) => {
  const [mediaUrl, setMediaUrl] = useState(null);
  const [audioUrl, setAudioUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [videoLoading, setVideoLoading] = useState(false);
  const [showReactions, setShowReactions] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  // const [replyMessage, setReplyMessage] = useState(null);


  // Fixed states for image/video zoom modal
  const [showModal, setShowModal] = useState(false);
  const [audioProgress, setAudioProgress] = useState(0);
  const [currentMediaUrl, setCurrentMediaUrl] = useState(null);

  // New states for reaction functionality
  const [holdTimer, setHoldTimer] = useState(null);
  const [isHolding, setIsHolding] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);


  const [message, setMessage] = useState(initialMessage); //  local state
  const imgRef = useRef(null);
  const videoRef = useRef(null);
  const audioRef = useRef(null);
  const messageRef = useRef(null);
  // console.log("Messages are :", message)

  // console.log("Messages are :", message.message_id, "Phones are :", phoneId)
  const { GetMediaUrl, SendReaction, socket } = useAPI();

  const { selectedWabaId } = useStateContex();
  const { direction, status, type, createdAt, phone_number_id } = message;




  const closesModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      setShowModal(false);
      setIsClosing(false);
    }, 300);
  };

  useEffect(() => {
    if (!socket) return;

    const handleStatusUpdate = (data) => {
      // console.log("message:status_update:", data)
      // if (data._doc.message_id === data._doc.message_id) {
      if (message.message_id === data._doc.message_id) {

        setMessage((prev) => ({ ...prev, status: data.status }));
        // setMessage((prev) => ({ ...prev, { status: data.status } }));
      }
    };

    socket.on("message:status_update", handleStatusUpdate);

    return () => {
      socket.off("message:status_update", handleStatusUpdate);
    };
  }, [socket, message.message_id]);



  // console.log("Last message type", message.type, message)

  const isSent = direction === "sent";

  // Detect if device is desktop
  useEffect(() => {
    const checkDevice = () => {
      setIsDesktop(window.innerWidth >= 768);
      // setIsDesktop(true);
    };

    checkDevice();
    window.addEventListener("resize", checkDevice);
    return () => window.removeEventListener("resize", checkDevice);
  }, []);





  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // Get media URL (generic)
  const fetchMediaUrl = async (id, setter) => {
    setLoading(true);
    setError(false);
    try {
      const url = await GetMediaUrl(id, phone_number_id);
      console.log("this is frontedn issueueuueeueu", url)
      setter(url);
    } catch (err) {
      console.error("❌ Failed to load media:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  // Image Lazy Load
  useEffect(() => {
    if (type !== "image" || !message?.image?.id) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !mediaUrl && !loading && !error) {
          fetchMediaUrl(message.image.id, setMediaUrl);
        }
      },
      { threshold: 0.1 }
    );

    const current = imgRef.current;
    if (current) observer.observe(current);
    return () => current && observer.unobserve(current);
  }, [type, message, mediaUrl, loading, error]);

  // Audio Load
  useEffect(() => {
    if (type === "audio" && message.audio?.id) {
      fetchMediaUrl(message.audio.id, setAudioUrl);
    }
  }, [type, message.audio?.id]);

  // Video Lazy Load
  useEffect(() => {
    if (type !== "video" || !message.video?.id) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !mediaUrl && !loading && !error) {
          setVideoLoading(true);
          fetchMediaUrl(message.video.id, setMediaUrl);
        }
      },
      { threshold: 0.1 }
    );

    const current = imgRef.current;
    if (current) observer.observe(current);
    return () => current && observer.unobserve(current);
  }, [type, message.video?.id, mediaUrl, loading, error]);

  // Document Lazy Load
  useEffect(() => {
    if (type !== "document" || !message.document?.id) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !mediaUrl && !loading && !error) {
          fetchMediaUrl(message.document.id, setMediaUrl);
        }
      },
      { threshold: 0.1 }
    );

    const current = imgRef.current;
    if (current) observer.observe(current);
    return () => current && observer.unobserve(current);
  }, [type, message.document?.id, mediaUrl, loading, error]);

  // Handle video load event
  const handleVideoLoad = () => {
    setVideoLoading(false);
  };

  // Handle media click for zoom - Fixed to prevent event bubbling
  const handleMediaClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if ((type === "image" || type === "video") && mediaUrl) {
      setShowModal(true);
    }
  };

  // Close modal - Fixed to prevent event bubbling
  const closeModal = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setShowModal(false);
  };

  // Handle backdrop click - only close if clicking the backdrop itself
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal(e);
    }
  };

  // Handle Reaction
  const handleReaction = async (emoji) => {
    try {
      // Check if this emoji is already the current reaction
      const isCurrentReaction = message.reaction?.emoji === emoji;

      // Check if required values exist
      if (!message.message_id) {
        console.error("❌ message.message_id is missing!");
        return;
      }

      if (!phoneId) {
        console.error("❌ phoneId prop is missing!");
        return;
      }

      const reactionData = {
        messageId: message.message_id,
        phone_number_id: phoneId,
        recipient_id: message.recipient_id,
        emoji: isCurrentReaction ? null : emoji,
      };

      await SendReaction(reactionData);
      setShowReactions(false);
    } catch (err) {
      console.error("❌ Failed to send reaction:", err);
      console.error("❌ Error response data:", err.response?.data);
      console.error("❌ Error message:", err.message);
    }
  };

  // Desktop reaction handlers (click arrow to show reactions)
  const handleDesktopReaction = (e) => {
    e.stopPropagation();
    setShowReactions(!showReactions);
  };

  // Mobile reaction event handlers (long press)
  const handleMouseDown = (e) => {
    if (isDesktop) return; // Don't use long press on desktop

    e.preventDefault();
    setIsHolding(true);
    const timer = setTimeout(() => {
      setShowReactions(true);
    }, 500); // 500ms hold duration
    setHoldTimer(timer);
  };

  const handleMouseUp = (e) => {
    if (isDesktop) return;

    if (holdTimer) {
      clearTimeout(holdTimer);
      setHoldTimer(null);
    }
    setIsHolding(false);
  };

  const handleMouseLeave = () => {
    if (isDesktop) return;

    if (holdTimer) {
      clearTimeout(holdTimer);
      setHoldTimer(null);
    }
    setIsHolding(false);
  };

  // Touch event handlers for mobile
  const handleTouchStart = (e) => {
    if (isDesktop) return;

    e.preventDefault();
    setIsHolding(true);
    const timer = setTimeout(() => {
      setShowReactions(true);
    }, 500);
    setHoldTimer(timer);
  };

  const handleTouchEnd = (e) => {
    if (isDesktop) return;

    e.preventDefault();
    if (holdTimer) {
      clearTimeout(holdTimer);
      setHoldTimer(null);
    }
    setIsHolding(false);
  };

  const handleTouchCancel = () => {
    if (isDesktop) return;

    if (holdTimer) {
      clearTimeout(holdTimer);
      setHoldTimer(null);
    }
    setIsHolding(false);
  };

  // Close reactions when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (messageRef.current && !messageRef.current.contains(event.target)) {
        setShowReactions(false);
      }
    };

    if (showReactions) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [showReactions]);

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (holdTimer) {
        clearTimeout(holdTimer);
      }
    };
  }, [holdTimer]);

  // Close modal on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && showModal) {
        setShowModal(false);
      }
    };

    if (showModal) {
      document.addEventListener("keydown", handleEscape);
      // Prevent body scroll when modal is open
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [showModal]);

  // Toggle audio play/pause
  const toggleAudio = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };




  // Get status icon
  const getStatusIcon = (status) => {
    const s = status?.toLowerCase();

    if (["pending", "sent"].includes(s))
      return <Check size={16} className="text-gray-400" strokeWidth={2} />;

    if (s === "delivered")
      return <CheckCheck size={16} className="text-gray-400" strokeWidth={2} />;

    if (s === "read")
      return <CheckCheck size={16} className="text-blue-500" strokeWidth={2.5} />;

    if (s === "failed") {
      const reason =
        message?.failed_reason?.trim() ||
        "Message failed to send";

      return (
        <span title={reason} className="cursor-help">
          <PiWarningCircleBold size={16} className="text-red-500" />
        </span>
      );
    }

    return null;
  };

  // Get file extension
  const getFileExtension = (filename) => {
    return filename?.split(".").pop()?.toUpperCase() || "FILE";
  };

  useEffect(() => {
    if (showModal) {
      setCurrentMediaUrl(mediaUrl);
    }
  }, [showModal, mediaUrl]);

  // return modern icon component based on event
  const getSystemIcon = (event) => {
    switch (event) {
      case "call_permission_request":
        return <Bell size={16} className="text-yellow-500" />;

      case "call_permission_reply":
        return <ShieldCheck size={16} className="text-green-500" />;

      case "call_status":
        return <PhoneOutgoing size={16} className="text-blue-500" />;

      default:
        return <Info size={16} className="text-gray-400" />;
    }
  };



  if (type === "system") {
    return (
      <div className="flex justify-center my-3">
        <div
          className="
          flex items-center gap-2
          bg-[#f0f2f5]
          text-[#667781]
          text-[12px]
          px-3 py-1.5
          rounded-lg
          max-w-[75%]
          whitespace-nowrap
        "
        >
          {getSystemIcon(message.system?.event)}

          <span className="leading-none">
            {message.system?.message}
          </span>
        </div>
      </div>
    );
  }

  const isMissed = message.call.outcome === "missed" || message.call.status === "missed";

  const formatDateBadge = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const isToday =
      date.toDateString() === today.toDateString();

    const isYesterday =
      date.toDateString() === yesterday.toDateString();

    if (isToday) return "Today";
    if (isYesterday) return "Yesterday";

    return date.toLocaleDateString([], {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <>
      {/* <div className={`flex ${isSent ? "justify-end" : "justify-start"} mb-10`}> */}
      <div className={`flex ${isSent ? "justify-end" : "justify-start"} mb-10 ${isSent ? "ml-auto" : "mr-auto"} max-w-[60%]`}>
        <div
          className={`group flex items-end gap-1 ${isSent ? "flex-row" : "flex-row-reverse"
            }`}
        >
          {/* Desktop reaction arrow - appears on hover */}
          {isDesktop && (
            <button
              onClick={handleDesktopReaction}
              className={`opacity-0 group-hover:opacity-100 justify-center transition-all duration-200 p-1.5 rounded-full hover:bg-gray-300 bg-gray-200 shadow-sm ${isSent ? "ml-1" : "mr-1"
                }`}
              title="Add reaction"
            >
              <Smile size={16} className="text-gray-600 hover:text-gray-800" />
            </button>
          )}





          <div
            ref={messageRef}
            className={`relative px-3 py-1 text-sm rounded-lg cursor-pointer whitespace-pre-wrap break-words
    ${
              // REMOVE background for:
              (type === "image" && !message.image?.caption) ||
                (type === "video" && !message.video?.caption) ||
                type === "document"
                ? ""
                : isSent
                  ? "bg-[#d9fdd3] rounded-tr-none shadow-sm border border-gray-200"
                  : "bg-white rounded-tl-none shadow-sm border border-gray-200"
              }
    ${isHolding ? "scale-95 transition-transform duration-150" : ""}
  `}
          >



            {/* IMAGE */}
            {type === "image" && (
              <div className="flex flex-col items-start">
                <div
                  ref={imgRef}
                  className="relative rounded-xl overflow-hidden  hover:shadow-lg transition-shadow duration-200"
                  onClick={handleMediaClick}
                >
                  {/* Loading skeleton */}
                  {loading && (
                    <div className="w-80 h-60 bg-gray-200 animate-pulse flex items-center justify-center rounded-xl">
                      <span className="text-gray-500 text-xs">Loading...</span>
                    </div>
                  )}

                  {/* Error reload */}
                  {error && (
                    <div
                      className="w-80 h-60 flex flex-col items-center justify-center bg-red-100 border border-red-500 rounded-xl cursor-pointer p-3"
                      onClick={() =>
                        fetchMediaUrl(message.image.id, setMediaUrl)
                      }
                    >
                      <p className="text-red-700 font-semibold text-center text-sm mb-1">
                        Failed to load
                      </p>
                      <RefreshCw size={18} className="text-red-700" />
                    </div>
                  )}

                  {/* Image */}
                  {!loading && !error && mediaUrl && (
                    <img
                      src={mediaUrl}
                      alt={message.image?.caption || "Sent image"}
                      className={`
      w-full max-w-[320px] 
      rounded-xl 
      object-cover 
      shadow-sm
      hover:shadow-md 
      transition-shadow duration-200
    `}
                      style={{
                        minHeight: "220px",
                        maxHeight: "450px",
                      }}
                      loading="lazy"
                    />
                  )}

                  {/* Timestamp overlay */}
                  {!message.image?.caption && (
                    <div className="absolute bottom-1 right-1 flex items-center gap-1 text-[11px] bg-black/40 text-white px-1.5 py-0.5 rounded-md">
                      {formatTime(createdAt)}
                      {isSent && getStatusIcon(status)}
                    </div>
                  )}



                </div>

                {/* Caption under image */}
                {message.image?.caption && (
                  <p className="text-sm text-gray-800 mt-1 px-1 break-words">
                    {message.image?.caption}
                  </p>
                )}
              </div>
            )}

            {/* TEXT */}
            {type === "text" && (
              <div className="text-gray-800 break-words ">
                {message.text?.body}
              </div>
            )}

            {/* CALL MESSAGE */}
            {type === "call" && message.call && (
              <div
                className={`flex items-center gap-3 py-2.5 px-3 min-w-[220px] max-w-[320px] rounded-xl 
    ${isSent ? "bg-[#d9fdd3] rounded-tr-none shadow-sm" : "bg-white rounded-tl-none "}`}
              >
                {/* Icon  */}
                {/* <div
                  className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full 
      ${message.call.outcome === "missed" || message.call.status === "missed"
                      ? "bg-red-100"
                      : isSent
                        ? "bg-[#008069]"
                        : "bg-gray-200"
                    }`}
                >
                  {message.call.outcome === "missed" || message.call.status === "missed" ? (
                    <PhoneIncoming size={18} className="text-red-500" />
                  ) : isSent ? (
                    <PhoneOutgoing size={18} className="text-white" />
                  ) : (
                    <PhoneIncoming size={18} className="text-[#008069]" />
                  )}
                </div> */}
                <div
                  className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full 
    ${isMissed ? "bg-red-100" : isSent ? "bg-[#008069]" : "bg-gray-200"}
  `}
                >
                  {isMissed ? (
                    isSent ? (
                      //  YOU called but missed → outgoing missed
                      <PhoneOutgoing size={18} className="text-red-500" />
                    ) : (
                      //  THEY called but missed → incoming missed
                      <PhoneIncoming size={18} className="text-red-500" />
                    )
                  ) : isSent ? (
                    //  normal outgoing
                    <PhoneOutgoing size={18} className="text-white" />
                  ) : (
                    // normal incoming
                    <PhoneIncoming size={18} className="text-[#008069]" />
                  )}
                </div>

                {/* Call Details */}
                <div className="flex flex-col gap-[2px]">
                  <span className="text-[13.5px] font-semibold text-[#111b21] leading-snug">
                    {message.call.outcome === "missed" || message.call.status === "missed"
                      ? message.call.type === "video"
                        ? "Missed video call"
                        : "Missed voice call"
                      : message.call.type === "video"
                        ? "Video call"
                        : "Voice call"}
                  </span>
                  <span className="text-[11.5px] text-[#667781] leading-snug">
                    {message.call.duration
                      ? `${Math.floor(message.call.duration / 60)}:${String(
                        message.call.duration % 60
                      ).padStart(2, "0")} call`
                      : "Return calls on your phone"}
                  </span>
                </div>
              </div>
            )}

            {/* =================  AUDIO  ================= */}
            {type === "audio" && (
              <div className={`py-1 flex ${isSent ? "justify-end" : "justify-start"}`}>
                {audioUrl && !error ? (
                  <div
                    className={`
        max-w-[320px] min-w-[220px] 
        flex items-center gap-3 px-3 py-1 -mb-2 rounded-xl
        ${isSent ? "" : "bg-white border border-none"}
        
      `}
                  >
                    {/* Play / Pause - WhatsApp style */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleAudio();
                      }}
                      className={`
            w-10 h-10 rounded-full 
            flex items-center justify-center flex-shrink-0
            ${isSent ? "bg-[#008069]" : "bg-[#f0f2f5]"}
          `}
                    >
                      {isPlaying ? (
                        <Pause size={18} className={`${isSent ? "text-white" : "text-[#008069]"}`} />
                      ) : (
                        <Play size={18} className={`${isSent ? "text-white" : "text-[#008069]"} ml-0.5`} />
                      )}
                    </button>

                    {/* Waveform  */}
                    <div className="flex-1 flex items-center min-w-0">
                      <div className="flex items-center gap-[2px] h-6 w-full">
                        {[4, 6, 10, 5, 9, 7, 8, 6, 10, 5, 9, 7, 8, 6, 10, 5, 9, 7, 8, 6, 10, 5, 9, 7, 8, 6, 10, 5, 9, 7].map((height, i) => {
                          const currentProgress = audioProgress;
                          const barPosition = (i / 30) * 100;
                          const isActive = barPosition <= currentProgress;

                          return (
                            <div
                              key={i}
                              className={`w-[2px] rounded-full transition-colors duration-75 
                  ${isActive
                                  ? isSent
                                    ? "bg-[#008069]"
                                    : "bg-[#09d261]"
                                  : "bg-gray-400"
                                }`}
                              style={{
                                height: `${height * 1.5}px`,
                                maxHeight: "16px",
                              }}
                            />
                          );
                        })}
                      </div>
                    </div>

                    {/* Time  */}
                    <span className="text-[11px] text-gray-600 flex-shrink-0 min-w-[32px] text-right tabular-nums">
                      {audioRef.current?.duration
                        ? (() => {
                          const remaining = Math.ceil(
                            audioRef.current.duration -
                            (audioRef.current.currentTime || 0)
                          );
                          return `${Math.floor(remaining / 60)}:${(
                            remaining % 60
                          )
                            .toString()
                            .padStart(2, "0")}`;
                        })()
                        : "0:00"}
                    </span>

                    {/* Hidden Audio Element */}
                    <audio
                      ref={audioRef}
                      src={audioUrl}
                      onTimeUpdate={() => {
                        if (audioRef.current && audioRef.current.duration) {
                          const progress =
                            (audioRef.current.currentTime /
                              audioRef.current.duration) *
                            100;
                          setAudioProgress(progress);
                        }
                      }}
                      onLoadedMetadata={() => setAudioProgress(0)}
                      onEnded={() => {
                        setIsPlaying(false);
                        setAudioProgress(0);
                      }}
                    />
                  </div>
                ) : error ? (
                  <div
                    className="flex items-center gap-2 p-2 bg-red-50 border border-red-300 rounded-full cursor-pointer hover:bg-red-100 transition"
                    onClick={(e) => {
                      e.stopPropagation();
                      fetchMediaUrl(message.audio.id, setAudioUrl);
                    }}
                  >
                    <span className="text-red-600 text-sm font-medium">Failed to load</span>
                    <RefreshCw size={14} className="text-red-600" />
                  </div>
                ) : (
                  <div className="flex items-center gap-2 p-2">
                    <div className="animate-pulse w-5 h-5 bg-gray-300 rounded-full" />
                    <span className="text-gray-500 text-sm">Loading...</span>
                  </div>
                )}
              </div>
            )}


            {/* VIDEO */}
            {type === "video" && (
              <div
                className="flex flex-col items-start max-w-sm w-full"
                ref={imgRef}
              >
                {loading && (
                  <div className="w-full max-w-sm h-[250px] bg-gray-200 animate-pulse flex items-center justify-center rounded-xl">
                    <span className="text-gray-500 text-sm">
                      Loading video...
                    </span>
                  </div>
                )}
                {error && (
                  <div
                    className="w-full max-w-sm h-[250px] bg-red-100 flex flex-col items-center justify-center cursor-pointer border border-red-500 rounded-xl p-4 hover:bg-red-200 transition-colors"
                    onClick={(e) => {
                      e.stopPropagation();
                      setVideoLoading(true);
                      fetchMediaUrl(message.video.id, setMediaUrl);
                    }}
                  >
                    <p className="text-red-700 font-semibold mb-1">
                      Failed to load video
                    </p>
                    <RefreshCw size={20} className="text-red-700" />
                  </div>
                )}
                {!loading && !error && mediaUrl && (
                  <div
                    className={`relative cursor-pointer rounded-xl overflow-hidden w-full max-w-sm ${isSent ? "" : "border border-gray-200"
                      }`}
                    onClick={handleMediaClick}
                  >
                    <video
                      className="w-full object-cover"
                      style={{
                        minHeight: "200px",
                        maxHeight: "300px",
                      }}
                      src={mediaUrl}
                      onCanPlay={handleVideoLoad}
                      onLoadedData={handleVideoLoad}
                    />

                    {/* Play button overlay - center */}
                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                      <div className="w-14 h-14 rounded-full bg-black/60 flex items-center justify-center">
                        <Play size={24} className="text-white ml-1" fill="white" />
                      </div>
                    </div>

                    {/* Video duration - top left */}
                    {/* {message.video?.duration && (
                      <div className="absolute top-2 left-2 bg-black/60 text-white text-xs px-2 py-0.5 rounded">
                        {formatVideoDuration(message.video.duration)}
                     </div>
                    )} */}

                    {/* Timestamp - bottom right */}
                    <div className="absolute bottom-2 right-2 flex items-center gap-1 text-[11px] bg-black/60 text-white px-1.5 py-0.5 rounded">
                      <span>{formatTime(createdAt)}</span>
                      {/* Check it not a call */}
                      {isSent && (
                        <span className="flex items-center">
                          {getStatusIcon(status)}
                        </span>
                      )}
                    </div>
                  </div>
                )}
                {message.video?.caption && (
                  <p className="text-sm text-gray-700 mt-1 break-words">
                    {message.video.caption}
                  </p>
                )}
              </div>
            )}


            {type === "template" && message.template && (
              <TemplateMessage
                template={message.template}
                // GetMediaUrl={GetMediaUrl}
                phone_number_id={phone_number_id}
              />
            )}


            {/* DOCUMENT */}
            {type === "document" && (
              <div className="flex flex-col items-start" ref={imgRef}>
                {loading && (
                  <div className="w-full max-w-sm rounded-xl overflow-hidden animate-pulse bg-gray-100">

               

                    {/* Bottom section skeleton */}
                    <div className="flex items-center gap-3 p-3">
                      <div className="w-10 h-12 bg-gray-300 rounded"></div>

                      <div className="flex-1 space-y-2">
                        <div className="h-3 w-28 bg-gray-300 rounded"></div>
                        <div className="h-2 w-20 bg-gray-300 rounded"></div>
                      </div>

                      <div className="w-8 h-8 bg-gray-300 rounded-full"></div>
                    </div>

                    <div className="h-3 w-16 bg-gray-300 rounded ml-auto mr-2 mb-2"></div>
                  </div>
                )}

                {error && (
                  <div
                    className="w-full p-3 bg-red-100 flex items-center gap-3 rounded-xl border border-red-500 cursor-pointer hover:bg-red-200 transition-colors"
                    onClick={(e) => {
                      e.stopPropagation();
                      fetchMediaUrl(message.document.id, setMediaUrl);
                    }}
                  >
                    <div className="w-10 h-12 bg-red-200 rounded flex items-center justify-center">
                      <RefreshCw size={18} className="text-red-700" />
                    </div>
                    <div>
                      <p className="text-red-700 font-medium text-sm">
                        Failed to load document
                      </p>
                      <p className="text-red-600 text-xs">Click to retry</p>
                    </div>
                  </div>
                )}
                {!loading && !error && mediaUrl && (
                  <a
                    href={mediaUrl}
                    download={message.document.filename}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    className={`w-full max-w-sm rounded-xl overflow-hidden transition
                    ${isSent ? "bg-[#d9fdd3]" : "bg-white border border-gray-200"}
                  `}
                  >

            



                    {/* Bottom Info Section */}
                    <div className="flex items-center gap-3 p-3">

                      {/* File Icon */}
                      <div className="w-10 h-12 bg-red-500 rounded flex flex-col items-center justify-center text-white">
                        <FileText size={16} />
                        <span className="text-[9px] font-bold">
                          {getFileExtension(message.document.filename).toUpperCase()}
                        </span>
                      </div>

                      {/* File Details */}
                      <div className="flex-1 overflow-hidden">
                        <p className="text-sm font-semibold text-gray-800 truncate">
                          {message.document.filename}
                        </p>
                        <p className="text-xs text-gray-600 mt-1">
                          {getFileExtension(message.document.filename).toUpperCase()} •{" "}
                          {message.document.size || "19 kB"}
                        </p>
                      </div>

                      {/* Download Circle */}
                      <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center">
                        <Download size={16} className="text-gray-600" />
                      </div>
                    </div>

                    {/* Timestamp */}
                    <div className="flex items-center justify-end gap-1 text-[11px] text-gray-600 pr-2 pb-1">
                      <span>{formatTime(createdAt)}</span>
                      {isSent && (
                        <span className="flex items-center">
                          {getStatusIcon(status)}
                        </span>
                      )}
                    </div>

                  </a>
                )}
                {message.document?.caption && (
                  <p className="text-sm text-gray-700 mt-1 break-words">
                    {message.document.caption}
                  </p>
                )}
              </div>
            )}

     

            {/* TIME & STATUS */}
            {(
              (type !== "document" && type !== "video" && type !== "image") ||
              (type === "image" && message.image?.caption)
            ) && (
                <div className="text-xs text-gray-500 flex items-center gap-1 mt-1 justify-end">
                  {formatTime(createdAt)}
                  {isSent && getStatusIcon(status)}
                </div>
              )}


            {/* EXISTING REACTION DISPLAY */}
            {message.reaction?.emoji && (
              <div
                className={`absolute -bottom-7 ${isSent ? "right-3" : "left-3"
                  } bg-white rounded-full shadow-md border border-gray-200 px-1.5 py-0.5 text-lg`}
              >
                {message.reaction.emoji}
              </div>
            )}

            {/* REACTION PICKER */}
            {showReactions && (
              <div
                className={`absolute -top-14 ${isSent ? "right-0 origin-right animate-reaction-right" : "left-0 origin-left animate-reaction-left"
                  } 
    bg-white border rounded-full shadow-xl 
    flex space-x-2 px-3 py-2 z-50`}
                onClick={(e) => e.stopPropagation()}
              >
                {REACTIONS.map((emoji) => {
                  const isSelected = message.reaction?.emoji === emoji;

                  return (
                    <button
                      key={emoji}
                      onClick={() => handleReaction(emoji)}
                      className={`text-2xl transition-transform duration-150
            hover:scale-125 active:scale-95
            ${isSelected ? "scale-125" : ""}`}
                    >
                      {emoji}
                    </button>
                  );
                })}
              </div>
            )}


          </div>
        </div>
      </div>

      {/* FIXED MODAL FOR IMAGE/VIDEO ZOOM */}
      {showModal && currentMediaUrl && (type === "image" || type === "video") && (
        <div
          data-modal="true"
          className={`absolute top-[60px] left-0 right-0 bottom-0 
                bg-white/20 backdrop-blur-2xl 
                flex flex-col z-[200]
                ${isClosing ? 'animate-[fadeOut_0.3s_ease-out]' : 'animate-[fadeIn_0.3s_ease-out]'}`}
          style={{
            animation: isClosing ? 'fadeOut 0.3s ease-out' : 'fadeIn 0.3s ease-out'
          }}
        >
          {/* Header */}
          <div
            className={`flex items-center px-6 py-4 bg-white shadow-sm relative border-b
                  ${isClosing ? 'animate-[slideUp_0.4s_ease-out]' : 'animate-[slideDown_0.4s_ease-out]'}`}
            style={{
              animation: isClosing ? 'slideUp 0.4s ease-out' : 'slideDown 0.4s ease-out'
            }}
          >
            <button
              onClick={closesModal}
              className="text-gray-600 hover:text-black transition p-2 hover:bg-gray-100 rounded-full"
            >
              <X size={20} />
            </button>
            <span className="text-gray-800 text-sm font-medium absolute left-1/2 -translate-x-1/2 truncate max-w-[60%]">
              {type === "image"
                ? message.image?.caption || "Photo"
                : message.video?.caption || "Video"}
            </span>
          </div>

          {/* Content */}
          <div className="flex-1 flex items-center justify-center px-10 relative overflow-hidden bg-white/40 backdrop-blur-md">
            {/* LEFT ARROW */}
            <button
              className={`absolute left-6 top-1/2 -translate-y-1/2 
                    bg-white/90 backdrop-blur-sm
                    border shadow-md 
                    hover:shadow-lg hover:bg-white 
                    rounded-full w-11 h-11 
                    flex items-center justify-center 
                    text-gray-700 hover:text-black 
                    transition duration-200
                    ${isClosing ? 'animate-[slideOutLeft_0.5s_ease-out]' : 'animate-[slideInLeft_0.5s_ease-out]'}`}
              style={{
                animation: isClosing ? 'slideOutLeft 0.5s ease-out' : 'slideInLeft 0.5s ease-out'
              }}
            >
              <ChevronLeft size={22} strokeWidth={2.5} />
            </button>

            {/* MEDIA */}
            {type === "image" && (
              <img
                src={currentMediaUrl}
                alt="preview"
                className={`max-h-[75vh] max-w-[85%] object-contain rounded-lg shadow
                      ${isClosing ? 'animate-[scaleOut_0.4s_ease-out]' : 'animate-[scaleIn_0.4s_ease-out]'}`}
                style={{
                  animation: isClosing ? 'scaleOut 0.4s ease-out' : 'scaleIn 0.4s ease-out'
                }}
              />
            )}
            {type === "video" && (
              <video
                src={currentMediaUrl}
                controls
                autoPlay
                className={`max-h-[75vh] max-w-[85%] rounded-lg shadow
                      ${isClosing ? 'animate-[scaleOut_0.4s_ease-out]' : 'animate-[scaleIn_0.4s_ease-out]'}`}
                style={{
                  animation: isClosing ? 'scaleOut 0.4s ease-out' : 'scaleIn 0.4s ease-out'
                }}
              />
            )}


            {/* RIGHT ARROW */}
            <button
              className={`absolute right-6 top-1/2 -translate-y-1/2 
                    bg-white/90 backdrop-blur-sm
                    border shadow-md 
                    hover:shadow-lg hover:bg-white 
                    rounded-full w-11 h-11 
                    flex items-center justify-center 
                    text-gray-700 hover:text-black 
                    transition duration-200
                    ${isClosing ? 'animate-[slideOutRight_0.5s_ease-out]' : 'animate-[slideInRight_0.5s_ease-out]'}`}
              style={{
                animation: isClosing ? 'slideOutRight 0.5s ease-out' : 'slideInRight 0.5s ease-out'
              }}
            >
              <ChevronRight size={22} strokeWidth={2.5} />
            </button>
          </div>

          {/* Footer */}
          {(message.image?.caption || message.video?.caption) && (
            <div
              className={`px-6 py-4 bg-white border-t text-center
                    ${isClosing ? 'animate-[slideDown_0.4s_ease-out]' : 'animate-[slideUp_0.4s_ease-out]'}`}
              style={{
                animation: isClosing ? 'slideDown 0.4s ease-out' : 'slideUp 0.4s ease-out'
              }}
            >
              <p className="text-gray-600 text-sm">
                {type === "image"
                  ? message.image?.caption
                  : message.video?.caption}
              </p>
            </div>
          )}
        </div>
      )}




    </>
  );
};

export default Message;
